import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-delete-fence',
    templateUrl: './delete-fence.component.html',
    styleUrls: ['./delete-fence.component.css'],
    standalone: true,
    imports: [CommonModule, MatDialogModule, MatButtonModule]
})
export class DeleteFenceComponent implements OnInit {
  fenceName = inject(MAT_DIALOG_DATA);


  ngOnInit(): void {
  }

}
